<script setup lang="ts">
//import { Badge } from '@laam/ui/base';
import { useRoute } from 'vue-router';
import type { JSX } from 'vue/jsx-runtime';
import { useArticlesQuery } from '~/data/articles';
import type { Article } from '~/types/blogs';
import { PhCaretLeft } from '@phosphor-icons/vue';
import { IconButton } from '@laam/ui/base';

const route = useRoute();
const router = useRouter();

const articleId = route.params.id as string;

const {
	data: article,
	isLoading,
	error,
	suspense,
} = useArticlesQuery(articleId);

onServerPrefetch(async () => {
	await suspense();
});

const getImageUrl = (image: Article['attributes']['image']) => {
	if (image?.data?.[0]?.attributes?.formats) {
		return (
			image.data[0].attributes.formats.large?.url ||
			image.data[0].attributes.formats.medium?.url ||
			image.data[0].attributes.formats.small?.url ||
			image.data[0].attributes.formats.thumbnail?.url
		);
	}
	return '';
};

const Body = {
	render(): JSX.Element {
		return h('div', {
			innerHTML: article.value?.attributes.body_html,
		});
	},
};

useHead(() => ({
	title: article.value?.attributes.title,
	description: article.value?.attributes.description,
}));
</script>

<template>
	<div>
		<div
			v-if="isMobileView()"
			class="py-md px-sm lg:py-3xl mobile_header flex items-center justify-between w-full bg-white border-b border-gray-200"
		>
			<IconButton
				size="nav-button"
				variant="icon"
				@click="
					() => {
						router.go(-1);
					}
				"
			>
				<PhCaretLeft />
			</IconButton>
			<div
				v-if="article"
				class="text-sm font-semibold text-gray-700 truncate w-full"
			>
				{{ article.attributes.title }}
			</div>
		</div>
		<div class="mt-10xl">
			<div class="lg:p-12xl px-3xl article-page">
				<div v-if="isLoading" class="text-center p-10xl">Loading...</div>
				<div v-else-if="error" class="text-center text-red-500">
					Error loading article: {{ error.message }}
				</div>
				<div v-else-if="article" class="flex flex-col gap-10xl">
					<div class="text-center text-gray-900 text-5xl font-semibold">
						<h1>{{ article.attributes.title }}</h1>
					</div>
					<div
						v-if="article.attributes.summary_html"
						class="text-center text-gray-700 text-xl"
					>
						<div>{{ article.attributes.summary_html }}</div>
					</div>
					<div class="relative">
						<img
							:src="getImageUrl(article.attributes.image)"
							:alt="article.attributes.image_alt"
						/>
					</div>
					<div>
						{{ article.attributes.description }}
					</div>
					<!-- <div v-html="article.attributes.body_html"></div> -->
					<Body />
				</div>
			</div>
		</div>
	</div>
</template>
